import { render, staticRenderFns } from "./ActivityRuleAndRecord.vue?vue&type=template&id=5387913a&scoped=true&"
import script from "./ActivityRuleAndRecord.vue?vue&type=script&lang=js&"
export * from "./ActivityRuleAndRecord.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRuleAndRecord.vue?vue&type=style&index=0&id=5387913a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5387913a",
  null
  
)

export default component.exports